import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { SideBar, NavBar, Footer, TitleAndDescription } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
const { formatarReal } = require("../../utils");

class AbcProduto extends Component {
  constructor() {
    super();
    this.load = this.load.bind(this);
    this.loadProdutos = this.loadProdutos.bind(this);
    this.paginar = this.paginar.bind(this);
    this.onChangePeriodo = this.onChangePeriodo.bind(this);
    this.onChangeAnalise = this.onChangeAnalise.bind(this);
    this.state = {
      periodo: "mesAtual", //mesAnterior
      produtos: [],
      produtosBkp: [],
      paginacao: {
        pagina: 1,
        limite: 10,
      },
      totalizador: 0,
      analise: "valor", //quantidade
    };
  }

  async componentDidMount() {
    await this.load();
  }

  async load() {
    await this.loadProdutos();
  }

  async loadProdutos() {
    await axios
      .get(
        `${this.props.getBaseUrlApi()}/relatorios/abc-produtos?periodo=${
          this.state.periodo
        }&analise=${this.state.analise}`,
        this.props.parameters()
      )
      .then((response) => {
        this.setState(
          {
            produtosBkp: response.data.produtos,
            totalizador: response.data.produtos.length,
          },
          () => {
            this.paginar(1);
          }
        );
      })
      .catch((error) => {
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status === 401) {
            this.props.logout();
          }
          if (error.response.status === 403) {
            this.props.history.push('/home')
          }
        }
      });
  }

  paginar(paginaAlterar) {
    this.setState({ paginacao: { pagina: paginaAlterar, limite: 10 } }, () => {
      let produtos = [...this.state.produtosBkp];
      paginaAlterar = paginaAlterar - 1;
      produtos = produtos.slice(
        paginaAlterar * this.state.paginacao.limite,
        (paginaAlterar + 1) * this.state.paginacao.limite
      );
      paginaAlterar = paginaAlterar + 1;

      this.setState({ produtos });
    });
  }

  onChangePeriodo(e) {
    this.setState({ periodo: e.target.value }, () => {
      this.loadProdutos();
    });
  }

  onChangeAnalise(e) {
    this.setState({ analise: e.target.value }, () => {
      this.loadProdutos();
    });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="ABC de Produtos" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"abc-produto"} />

            <div className="main-panel">
              <div className="content-wrapper">
                {/* <div className="row">
                  <div className="col-md-12 grid-margin">
                    <div className="d-flex justify-content-between flex-wrap">
                      <div className="d-flex align-items-end flex-wrap">
                        <div className="mr-md-3 mr-xl-5">
                          <h2>ABC de Produtos</h2>
                          <p className="mb-md-0 font-999">
                            Informações de curva ABC de produtos.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período
                                  </small>
                                  <div className="dropdown">
                                    <select
                                      className="no-border"
                                      style={{ fontWeight: "bold" }}
                                      value={this.state.periodo}
                                      onChange={(e) => this.onChangePeriodo(e)}
                                    >
                                      <option value="mesAtual">
                                        Mês Atual
                                      </option>
                                      <option value="mesAnterior">
                                        Mês Anterior
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Análise
                                  </small>
                                  <div className="dropdown">
                                    <select
                                      className="no-border"
                                      style={{ fontWeight: "bold" }}
                                      value={this.state.analise}
                                      onChange={(e) => this.onChangeAnalise(e)}
                                    >
                                      <option value="valor">Por Valor</option>
                                      <option value="quantidade">
                                        Por Quantidade
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="sales"
                            role="tabpanel"
                            aria-labelledby="sales-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/calendar.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "28px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Período
                                  </small>
                                  <div className="dropdown">
                                    <a
                                      className="btn btn-secondary dropdown-toggle p-0 bg-transparent border-0 text-dark shadow-none font-weight-medium"
                                      href="#"
                                      role="button"
                                      id="dropdownMenuLinkA"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <h5 className="mb-0 d-inline-block">
                                        Mês atual
                                      </h5>
                                    </a>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        Mês anterior
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-currency-usd mr-3 icon-lg text-danger font-000 font-size-30"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Total de orçamentos
                                  </small>
                                  <h5 className="mr-2 mb-0">30.020,00</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/button.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    N de orçamentos
                                  </small>
                                  <h5 className="mr-2 mb-0">30</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <img
                                  src="images/trash.png"
                                  alt="logo"
                                  className="mr-3 mx-3"
                                  style={{ width: "25px" }}
                                />
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Cancelados
                                  </small>
                                  <h5 className="mr-2 mb-0">2</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="tab-pane fade"
                            id="purchases"
                            role="tabpanel"
                            aria-labelledby="purchases-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div className="d-none d-xl-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-calendar-heart icon-lg mr-3 text-primary"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Start date
                                  </small>
                                  <div className="dropdown">
                                    <a
                                      className="btn btn-secondary dropdown-toggle p-0 bg-transparent border-0 text-dark shadow-none font-weight-medium"
                                      href="#"
                                      role="button"
                                      id="dropdownMenuLinkA"
                                      data-toggle="dropdown"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                    >
                                      <h5 className="mb-0 d-inline-block">
                                        26 Jul 2018
                                      </h5>
                                    </a>
                                    <div
                                      className="dropdown-menu"
                                      aria-labelledby="dropdownMenuLinkA"
                                    >
                                      <a className="dropdown-item" href="#">
                                        12 Aug 2018
                                      </a>
                                      <a className="dropdown-item" href="#">
                                        22 Sep 2018
                                      </a>
                                      <a className="dropdown-item" href="#">
                                        21 Oct 2018
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-currency-usd mr-3 icon-lg text-danger"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Revenue
                                  </small>
                                  <h5 className="mr-2 mb-0">$577545</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-eye mr-3 icon-lg text-success"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Total views
                                  </small>
                                  <h5 className="mr-2 mb-0">9833550</h5>
                                </div>
                              </div>
                              <div className="d-flex border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-download mr-3 icon-lg text-warning"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Downloads
                                  </small>
                                  <h5 className="mr-2 mb-0">2233783</h5>
                                </div>
                              </div>
                              <div className="d-flex py-3 border-md-right flex-grow-1 align-items-center justify-content-center p-3 item">
                                <i className="mdi mdi-flag mr-3 icon-lg text-danger"></i>
                                <div className="d-flex flex-column justify-content-around">
                                  <small className="mb-1 text-muted">
                                    Flagged
                                  </small>
                                  <h5 className="mr-2 mb-0">3497843</h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.produtos.length > 0 && (
                  <div className="row">
                    <div className="col-md-12 stretch-card">
                      <div className="card">
                        <div className="card-body">
                          <div className="table-responsive">
                            <table
                              id="recent-purchases-listing"
                              className="table"
                            >
                              <thead>
                                <tr>
                                  <th>Código</th>
                                  <th>Descrição</th>
                                  <th>U.M</th>
                                  <th className="text-right">
                                    {this.state.analise === "valor"
                                      ? "Valor"
                                      : "Quantidade"}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.produtos.map((produto, key) => (
                                  <tr key={key}>
                                    <td style={{ fontWeight: "bold" }}>
                                      #12345
                                    </td>
                                    <td>{produto.desc}</td>
                                    <td>{produto.unid}</td>
                                    <td className="text-right">
                                      {this.state.analise === "valor"
                                        ? `R$ ${formatarReal(
                                            produto.valorTotal
                                          )}`
                                        : `${produto.quantidadeTotal}`}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="paginacao">
                            <Pagination
                              prevPageText={<i className="fa fa-angle-left" />}
                              nextPageText={<i className="fa fa-angle-right" />}
                              firstPageText={
                                <i className="fa fa-angle-double-left" />
                              }
                              lastPageText={
                                <i className="fa fa-angle-double-right" />
                              }
                              activePage={this.state.paginacao.pagina}
                              itemsCountPerPage={this.state.paginacao.limite}
                              totalItemsCount={this.state.totalizador}
                              onChange={(pagina) => this.paginar(pagina)}
                              itemClass="page-item"
                              linkClass="page-link"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AbcProduto;
